"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftPayPeriodDto = instanceOfShiftPayPeriodDto;
exports.ShiftPayPeriodDtoFromJSON = ShiftPayPeriodDtoFromJSON;
exports.ShiftPayPeriodDtoFromJSONTyped = ShiftPayPeriodDtoFromJSONTyped;
exports.ShiftPayPeriodDtoToJSON = ShiftPayPeriodDtoToJSON;
exports.ShiftPayPeriodDtoToJSONTyped = ShiftPayPeriodDtoToJSONTyped;
/**
 * Check if a given object implements the ShiftPayPeriodDto interface.
 */
function instanceOfShiftPayPeriodDto(value) {
    if (!('canonicalStart' in value) || value['canonicalStart'] === undefined)
        return false;
    if (!('canonicalEnd' in value) || value['canonicalEnd'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    if (!('onCallMinutesWorked' in value) || value['onCallMinutesWorked'] === undefined)
        return false;
    return true;
}
function ShiftPayPeriodDtoFromJSON(json) {
    return ShiftPayPeriodDtoFromJSONTyped(json, false);
}
function ShiftPayPeriodDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'canonicalStart': (new Date(json['canonicalStart'])),
        'canonicalEnd': (new Date(json['canonicalEnd'])),
        'minutesWorked': json['minutesWorked'],
        'onCallMinutesWorked': json['onCallMinutesWorked'],
    };
}
function ShiftPayPeriodDtoToJSON(json) {
    return ShiftPayPeriodDtoToJSONTyped(json, false);
}
function ShiftPayPeriodDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'canonicalStart': ((value['canonicalStart']).toISOString()),
        'canonicalEnd': ((value['canonicalEnd']).toISOString()),
        'minutesWorked': value['minutesWorked'],
        'onCallMinutesWorked': value['onCallMinutesWorked'],
    };
}
//# sourceMappingURL=ShiftPayPeriodDto.js.map